import Chart from 'chart.js/auto';
import ChartDataLabels from 'chartjs-plugin-datalabels';

function getCSSCustomProperty(prop) {
  return getComputedStyle(document.documentElement).getPropertyValue(prop).trim();
}

function splitLabel(label, maxLength = 50) {
  if (label.length <= maxLength) {
    return [label];
  }

  const words = label.split(' ');
  if (words.length === 1) {
    const mid = Math.floor(label.length / 2);
    return [label.substring(0, mid), label.substring(mid)];
  }

  let firstLine = '';
  let secondLine = '';
  const halfLength = Math.floor(label.length / 2);

  for (let i = 0; i < words.length; i++) {
    if (firstLine.length + words[i].length <= halfLength && firstLine.length + words[i].length <= maxLength) {
      firstLine += (firstLine ? ' ' : '') + words[i];
    } else {
      secondLine += (secondLine ? ' ' : '') + words[i];
    }
  }

  return [firstLine || words[0], secondLine || words.slice(1).join(' ')];
}

function initHorizontalCharts() {
  const screenWidth = window.innerWidth;

  document.querySelectorAll('.horizontal-chart').forEach(canvas => {
    if (canvas.chart) {
      canvas.chart.destroy();
    }

    const ctx = canvas.getContext('2d');
    const originalLabels = (canvas.dataset.labels || '').split(',').map(s => s.trim());
    const chartData = JSON.parse(canvas.dataset.values.replace(/'/g, '"'));

    const chartLabels = originalLabels.map(label => splitLabel(label));

    const isSmallScreen = screenWidth < 780;
    const labelFontSize = isSmallScreen ? 9 : 12;

    const numberOfBars = chartLabels.length;
    const barHeight = isSmallScreen ? 50 : 70;
    const padding = isSmallScreen ? 80 : 120;
    const calculatedHeight = numberOfBars * barHeight + padding;

    canvas.style.height = calculatedHeight + 'px';
    canvas.height = calculatedHeight;

    canvas.chart = new Chart(ctx, {
      type: 'bar',
      data: {
        labels: chartLabels,
        datasets: [
          {
            label: 'Contrats en 2023',
            data: chartData,
            backgroundColor: '#3F2985',
            borderRadius: 6,
            borderWidth: 1,
            borderColor: 'black',
            barThickness: isSmallScreen ? 25 : 35,
          }
        ]
      },
      options: {
        indexAxis: 'y',
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          x: {
            beginAtZero: true,
            grid: { color: '#e5d6df' },
            ticks: { color: '#000' }
          },
          y: {
            grid: { display: false },
            ticks: {
              color: '#000',
              maxRotation: 0,
              minRotation: 0,
              font: {
                size: labelFontSize,
                family: getCSSCustomProperty('--font-family') || 'sans-serif'
              }
            }
          }
        },
        plugins: {
          legend: { display: false },
          tooltip: { enabled: false },
          datalabels: {
            anchor: 'end',
            align: 'right',
            color: '#000',
            font: { weight: 'bold' },
            formatter: value => value.toLocaleString()
          }
        }
      },
      plugins: [ChartDataLabels]
    });
  });
}

function debounce(func, wait) {
  let timeout;
  return function () {
    const context = this, args = arguments;
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(context, args), wait);
  };
}

window.addEventListener('load', initHorizontalCharts);
window.addEventListener('resize', debounce(initHorizontalCharts, 100));
